<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div id="main" v-else>
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ !isUpdate ? $t('adicionar') + ' ' + $t('cliente') : $t('cliente') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('promotor') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('cadastros') }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="redirectToPage()">
                                        {{ $t('cliente') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? $route.params.id
                                                : $t('adicionar') + ' ' + $t('cliente')
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'clientes-list' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <template v-if="isUpdate">
                    <ul class="nav nav-tabs nav-tabs-children">
                        <li
                            v-for="(aba, i) in abas"
                            :key="i"
                            v-show="permissao.read"
                            :class="{ active: abaSelecionada == i }"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul>

                    <!-- CONJUNTO DE ABAS - MOBILE -->
                    <b-dropdown aria-role="list" class="mobile-tab-list">
                        <div slot="trigger" class="mobile-tab">
                            <span class="mobile-tab-text">
                                {{ $t(abas[abaSelecionada]) }}
                            </span>
                            <em class="mdi mdi-chevron-down"></em>
                        </div>

                        <b-dropdown-item
                            class="mobile-tab-list-item"
                            :class="{ active: abaSelecionada == i }"
                            aria-role="listitem"
                            v-for="(aba, i) in abas"
                            v-show="permissao.read"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            {{ $t(aba) }}
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

                <DadosCadastrais
                    ref="tabDadosCadastrais"
                    v-if="abasAbertas['dados-cadastrais'] && !newToEdit && permissao.read"
                    v-show="abas[abaSelecionada] == 'dados-cadastrais'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                />

                <ContratoList
                    ref="tabContrato"
                    v-if="abasAbertas['contrato'] && permissao.read && isUpdate"
                    v-show="abas[abaSelecionada] == 'contrato'"
                />

                <MaoObraAlocada
                    ref="tabMaoObraAlocada"
                    v-if="abasAbertas['mao-de-obra-alocada'] && permissao.read && isUpdate"
                    v-show="abas[abaSelecionada] == 'mao-de-obra-alocada'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

// Abas
import DadosCadastrais from '@/components/promotor/cliente/abas/DadosCadastrais.vue';
import ContratoList from '@/components/promotor/cliente/abas/contrato/ContratoList.vue';
import MaoObraAlocada from '@/components/promotor/cliente/abas/MaoObraAlocada.vue';

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == 'clientes-new' && to.name == 'clientes-edit') {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        DadosCadastrais,
        ContratoList,
        MaoObraAlocada,
    },
    data() {
        return {
            accessDenied: false,
            abaSelecionada: 0,
            abas: ['dados-cadastrais', 'contrato', 'mao-de-obra-alocada'],
            abasAbertas: {},
            permissao: false,
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            debounceTab: null,
        };
    },
    mounted() {
        if (
            this.$route.query.abaSelecionada &&
            this.abas.includes(this.$route.query.abaSelecionada)
        ) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'clientes');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.accessDenied = true;
            return;
        }

        this.abasAbertas['dados-cadastrais'] = true;
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;

            clearTimeout(this.debounceTab);
            this.debounceTab = setTimeout(() => {
                // recria objeto de query da url com novo valor para tipo negócio
                let query = {};
                if (this.$route.query) {
                    query = Object.assign({}, this.$route.query);
                    if (query.abaSelecionada) delete query.abaSelecionada;
                }

                query.abaSelecionada = this.abas[this.abaSelecionada];
                // muda a url
                this.$router.push({ query: query });
            }, 400);
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        redirectToPage() {
            setTimeout(() => {
                this.$router.push({
                    name: 'clientes-list',
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
